import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';  // i18n을 먼저 초기화
import App from './App';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
